module.exports = __webpack_public_path__ + "media/application/images/home-logo-small-61fd9d26d72591d1b4438be4c225eab0.svg";